import { EUserRole } from '__generated__/globalTypes';
import { UserRoleField } from 'components/site/pages/ResellerPageContent/UserList/UserRoleField';
import { MainButton } from 'elements/button/MainButton';
import { SetEditorHeader } from 'elements/editor/SetEditorHeader';
import { ManagedUsers_managedUsers } from 'graphql/query/__generated__/ManagedUsers';
import { EColors, EFonts, EGrads, EHovers } from 'libs/styles/styling';
import _ from 'lodash';
import { useContext } from 'react';
import { GlobalContext } from 'session/state/context';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
    users: ManagedUsers_managedUsers[];
    onCreateUserclicked: () => void;
}

export const UserList = (props: Props): JSX.Element => {
    const globalContext = useContext(GlobalContext);
    const currentUser = globalContext.state.loggedUser;

    return (
        <S_UserList className={props.className}>
            <SetEditorHeader iconSet="far" iconName="list" title="List">
                <MainButton type={'primary'} onClick={props.onCreateUserclicked}>
                    Create user
                </MainButton>
            </SetEditorHeader>
            <S_TableHeader>
                <S_Title>Name</S_Title>
                <S_MapCount># of maps</S_MapCount>
                {currentUser.role === EUserRole.ADMIN && <S_Reseller> Reseller</S_Reseller>}
                <S_AccessType>Editor access</S_AccessType>
            </S_TableHeader>
            <S_Items>
                {_.orderBy(props.users, 'userId', 'asc')?.map((user, index) => {
                    return (
                        <S_Item key={user.userId} $odd={index % 2 === 0}>
                            <S_Title>{user.userId}</S_Title>
                            <S_MapCount>{user.worldMaps.length}</S_MapCount>
                            {currentUser.role === EUserRole.ADMIN && (
                                <S_Reseller>{user.resellerUserId}</S_Reseller>
                            )}
                            <S_AccessTypeField
                                userId={user.userId}
                                accessLevel={user.userAccessLevel}
                            />
                        </S_Item>
                    );
                })}
            </S_Items>
        </S_UserList>
    );
};

const S_UserList = styled.div`
    border-radius: 7px;
    background: #282727;
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3);
    border-radius: 7px;
    width: 800px;
    overflow: hidden;
`;

const S_Items = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 12px;
    width: 100%;
`;

const S_TableHeader = styled.div`
    display: flex;
    font-size: 14px;
    width: 100%;
    font-family: ${EFonts.Bold};
    color: ${EColors.WHITE};
    height: 50px;
    align-items: center;
    background: ${EGrads.BLACK_GRAD};
    padding: 0 20px;
`;

const S_Item = styled.div<{ $odd: boolean }>`
    height: 50px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    color: ${EColors.WHITE};
    font-size: 12px;
    font-family: ${EFonts.Regular};
    ${(props) => {
        return css`
            background: ${props.$odd ? 'rgba(255,255,255,0.02)' : 'unset'};
            &:hover {
                box-shadow: ${EHovers.LIGHT1};
            }
        `;
    }}
`;

const S_Title = styled.div`
    flex: 1;
`;

const S_MapCount = styled.div`
    flex: 1;
`;

const S_Reseller = styled.div`
    flex: 1;
`;

const S_AccessType = styled.div`
    flex: 1;
`;

const S_AccessTypeField = styled(UserRoleField)`
    flex: 1;
`;
